"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
require("./Modal.css");
var UIProps_1 = require("../UIProps");
var Button_1 = require("../button/Button");
var Icon_1 = require("../icon/Icon");
var react_transition_group_1 = require("react-transition-group");
var useOnClickOutside_1 = require("../../hooks/useOnClickOutside");
var ModalTheme;
(function (ModalTheme) {
    ModalTheme["basic"] = "basic";
    ModalTheme["page"] = "page";
    ModalTheme["slide"] = "slide";
})(ModalTheme = exports.ModalTheme || (exports.ModalTheme = {}));
var ModalComp = function (_a) {
    var _b = _a.groupId, groupId = _b === void 0 ? 'all' : _b, _c = _a.theme, theme = _c === void 0 ? ModalTheme.basic : _c, _d = _a.hasCloseButton, hasCloseButton = _d === void 0 ? true : _d, _e = _a.hasCloseOutside, hasCloseOutside = _e === void 0 ? true : _e, props = __rest(_a, ["groupId", "theme", "hasCloseButton", "hasCloseOutside"]);
    var modalId = react_1.useRef("_" + Math.random().toString(36).substr(2, 9));
    var miContainer = react_1.useRef(null);
    var focusOrigin = react_1.useRef(null); //element that invoked modal
    var modalContent = react_1.useRef(null);
    var focusables = react_1.useRef(null);
    react_1.useEffect(function () {
        miContainer.current = document.body.querySelector('.App_gridMain');
    }, []);
    react_1.useEffect(function () {
        window.addEventListener('modalGroupShow', onModalGroupShow, true);
        return function () {
            window.removeEventListener('modalGroupShow', onModalGroupShow);
        };
    }, [props.show, groupId]);
    react_1.useEffect(function () {
        setFocusables();
        return function () {
            resetFocusables();
        };
    }, [props.header, props.children, props.footer]);
    react_1.useEffect(function () {
        if (!props.show) {
            reset();
        }
    }, [props.show]);
    useOnClickOutside_1.useOnClickOutside(modalContent, function (e) {
        if (hasCloseOutside && props.show)
            onClose(e);
    }, [hasCloseOutside, props.show]);
    function reset() {
        document.body.removeEventListener('keyup', onKeyUp);
        document.body.classList.remove('position-fixed');
        document.body.classList.remove('w-100');
    }
    function setFocusables() {
        var modalElement = modalContent.current;
        if (modalElement !== null) {
            focusables.current = modalElement.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
            if (focusables.current && focusables.current.length > 0) {
                var firstFocusableElement = focusables.current[0];
                firstFocusableElement.addEventListener('keydown', onFirstElemKeyDown);
                var lastFocusableElement = focusables.current[focusables.current.length - 1];
                lastFocusableElement.addEventListener('keydown', onLastElemKeyDown);
            }
        }
    }
    function resetFocusables() {
        if (modalContent.current !== null) {
            if (focusables.current && focusables.current.length > 0) {
                var firstFocusableElement = focusables.current[0];
                var lastFocusableElement = focusables.current[focusables.current.length - 1];
                firstFocusableElement.removeEventListener('keydown', onFirstElemKeyDown);
                lastFocusableElement.removeEventListener('keydown', onLastElemKeyDown);
            }
        }
    }
    function onClose(e) {
        reset();
        props.onClose(e);
    }
    function onKeyUp(e) {
        if (e.defaultPrevented)
            return;
        var key = e.key || e.keyCode;
        //logger.info(e.key, e.keyCode);
        if (key === 'Escape' || key === 'Esc' || key === 27) {
            document.body.removeEventListener('keyup', onKeyUp);
            onClose(e);
        }
    }
    function onFirstElemKeyDown(e) {
        var key = e.key || e.keyCode;
        if (e.shiftKey && (key === 'Tab' || key === 'tab' || key === 9)) {
            e.preventDefault();
            focusables.current[focusables.current.length - 1].focus();
        }
    }
    function onLastElemKeyDown(e) {
        if (e.shiftKey)
            return;
        var key = e.key || e.keyCode;
        if (key === 'Tab' || key === 'tab' || key === 9) {
            e.preventDefault();
            focusables.current[0].focus();
        }
    }
    function onModalGroupShow(e) {
        if (e.detail.groupId === groupId &&
            e.detail.modalId !== modalId.current &&
            props.show) {
            onClose(e);
        }
    }
    var renderModal = function () { return (React.createElement(react_transition_group_1.CSSTransition, { in: props.show, timeout: 500, classNames: "Modal-" + theme, appear: true, unmountOnExit: true, onEnter: function () {
            focusOrigin.current = document.activeElement;
            //if (hasCloseOutside) document.body.addEventListener('click', onClickOutside, false);
            document.body.addEventListener('keyup', onKeyUp);
            if (groupId) {
                dispatchEvent(new CustomEvent('modalGroupShow', {
                    detail: { groupId: groupId, modalId: modalId.current },
                }));
            }
        }, onEntered: function () {
            document.body.classList.add('position-fixed');
            document.body.classList.add('w-100');
            //set focus when modal entered
            // if (focusables.current && focusables.current[0])
            //   focusables.current[0].focus()
            if (modalContent.current)
                modalContent.current.focus();
            if (props.onEntered)
                props.onEntered();
        }, onExit: function () {
            if (focusables.current && focusables.current.length > 0) {
                var firstFocusableElement = focusables.current[0];
                var lastFocusableElement = focusables.current[focusables.current.length - 1];
                firstFocusableElement.removeEventListener('keydown', onFirstElemKeyDown);
                lastFocusableElement.removeEventListener('keydown', onLastElemKeyDown);
            }
        }, onExited: function () {
            if (focusOrigin.current)
                focusOrigin.current.focus();
            if (props.onExited)
                props.onExited();
        } },
        React.createElement("div", __assign({ role: 'dialog', "aria-label": typeof props.header === 'string' ? props.header : 'Modal', tabIndex: -1 }, UIProps_1.setUIProps(props), { className: classnames_1.default('Modal', "Modal-" + theme, props.className) }),
            React.createElement("div", { className: "Modal_content", ref: modalContent, tabIndex: 0, role: 'document' },
                React.createElement("div", { className: classnames_1.default('Modal_header', {
                        'Modal_header-none': !props.header,
                    }) }, props.header),
                React.createElement("div", { className: "Modal_body" }, props.children),
                React.createElement("div", { className: 'Modal_footer' }, props.footer),
                hasCloseButton && (React.createElement(Button_1.Button, { className: 'Modal_closeButton', "aria-label": 'Modal close', onClick: onClose },
                    React.createElement(Icon_1.Icon, { type: Icon_1.IconType.close, "aria-hidden": true }))))))); };
    return miContainer.current
        ? react_dom_1.default.createPortal(renderModal(), miContainer.current)
        : renderModal();
};
exports.Modal = React.memo(ModalComp);
